export enum ImageModifier {
  CENTER_HORIZONTAL = 'center-horizontal',
  WIDTH_HEIGHT_100 = 'width-height-100',
  WIDTH_AUTO = 'width-auto',
  POP_UP = 'pop-up',
  SLIDER = 'slider',
}
